import { render, staticRenderFns } from "./SearchResultSidebar.vue?vue&type=template&id=278a7a5a&"
import script from "./SearchResultSidebar.vue?vue&type=script&lang=js&"
export * from "./SearchResultSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports